/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  var ariaLabels = {'pswp__button--close':'Close image gallery','pswp__button--share':'Share image','pswp__button--fs':'Toggle fullscreen','pswp__button--zoom':'Zoom image','pswp__button--arrow--left':'Previous image','pswp__button--arrow--right':'Next image'};
    function applyAriaLabels() { for (var cls in ariaLabels) { if (!ariaLabels.hasOwnProperty(cls)) continue; var els = document.querySelectorAll('.' + cls); for (var i = 0; i < els.length; i++) { els[i].setAttribute('aria-label', ariaLabels[cls]); } } }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', applyAriaLabels); } else { applyAriaLabels(); }
        document.addEventListener('click', function () { setTimeout(applyAriaLabels, 100); }, true);





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
